/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import FormText from 'components/pages/ResourceSetting/Widgets/FormText';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function TextField({
  title,
  description,
  value,
  onChange,
  disabled,
  required,
  maxLength,
  singleLine,
  squat,
  className,
  valid,
  style,
  ...props
}) {
  const id = `${title}-${description}-text-field`;
  return (
    <div className={classNames(Styles.mainContainer, className)}>
      <FormLabel
        title={title}
        description={description}
        disabled={disabled}
        required={required}
        htmlFor={id}
      />
      <FormText
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        maxLength={maxLength}
        singleLine={singleLine}
        squat={squat}
        valid={valid}
        style={style}
        {...props}
      />
    </div>
  );
}

TextField.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  maxLength: PropTypes.number,
  singleLine: PropTypes.bool,
  squat: PropTypes.bool,
  className: PropTypes.string,
  valid: PropTypes.bool,
  style: PropTypes.object,
};

TextField.defaultProps = {
  title: '',
  description: '',
  value: '',
  onChange: () => {},
  disabled: false,
  required: false,
  maxLength: -1,
  singleLine: false,
  squat: false,
  className: '',
  valid: true,
  style: {},
};
